import React, { useState, useEffect } from 'react';
import ReportViewer from '../components/ReportViewer';
import { Link } from 'react-router-dom';

const photos = [
  {
    src: '/images/home-page-gallery/me1.jpg',
    alt: 'Did I mention that I love building circuits? Here is me completing a photoresistor circuit.',
  },
  {
    src: '/images/home-page-gallery/me2.jpg',
    alt: 'Did I mention I love music? I started playing piano when I was 5.',
  },
];

export default function Home() {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  useEffect(() => {
    // On mount, pick a random photo index to display
    const randomIndex = Math.floor(Math.random() * photos.length);
    setCurrentPhotoIndex(randomIndex);
  }, []);

  const currentPhoto = photos[currentPhotoIndex];

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Welcome to My Design Portfolio!</h1>

      {/* Rotating Photo */}
      <div className="flex justify-center mb-8">
        <img
          src={currentPhoto.src}
          alt={currentPhoto.alt}
          className="w-48 h-48 rounded-lg shadow-md object-cover border-4 border-blue-200"
          key={currentPhoto.src} // ensures image updates correctly
        />
      </div>
      <p className="text-center text-gray-600 italic mb-8">{currentPhoto.alt}</p>

      {/* Intro Section */}
      <section className="mb-8">
        <p className="mb-4">
          Hello! I’m Jason, an incoming second year student studying environmental engineering at the University of 
          Waterloo! I'm passionate about software, robotics, and machine learning through
          leading my school's robotics programming subteam, and recently my hackathon sidequests. I seek to 
          utilize these experiences to create meaningful innovative solutions to solve environmental problems.
        </p>
      </section>

      {/* Internship and Link Section */}
      <section className="mb-8">
        <p>
          As a mechanical designer for my previous internship from January 2025 - May 2025, my eyes were further 
          opened to the world of industrial manufacturing, a mechanical side different from designing robots.
          I truly learned a lot, gained valuable experiences, and built meaningful relationships, and thus want to 
          dedicate this portfolio to showcasing some designs I created on co-op, as well as other CAD drawings
          I create since starting this engineering journey at UW, as I complete my personal website. 
          For more details on my other software projects, please visit my{' '}
          <Link to="/resume" className="text-blue-600 underline hover:text-blue-800">resume</Link>{' '}page.
        </p>
      </section>

      {/* Report Viewer */}
      <ReportViewer />
    </div>
  );
}
